import Vue from 'vue';

export class ServerBadge {
    /**
     * Изменение общих данных бейджа
     *
     * @param  badge: { id, first, last, about, position }
     * @return id
     */
  public static update(badge: any): Promise<any> {
    return new Promise((resolve, reject) => {
      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
              {
                "query": "mutation {
                  Badge (
                      _id:\\"${ badge.id }\\"
                      name: { first: \\"${ badge.first }\\" last: \\"${ badge.last }\\" gender: \\"male\\" }
                      about: \\"${ badge.about !== undefined ? badge.about: '' }\\"
                      position: \\"${ badge.position }\\"
                  ) {
                      _id
                    }
                }"
              }
            `
      })
        .then((resp: any) => {

          if (resp.data.status == 'ok') {
            resolve(resp.data);
          }

        })
        .catch((err: any) => {
          reject(err);
        });
    })
  }

    /**
     * Добавление контакта бейджа (телефон/email/сайт/соц. сеть)
     *
     * @param  badgeId, contacts: { title, type, value }
     * @return badgeId, contacts
    */
  public static addContact(badgeId: any, contacts: any): Promise<any> {
    return new Promise((resolve, reject) => {
      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
              {
                "query": "mutation {
                  Badge (
                      _id:\\"${badgeId}\\"
                      contacts: {
                        order: 1
                        title: \\"${ contacts.title }\\"
                        type: \\"${ contacts.type }\\"
                        value: \\"${ contacts.value }\\"
                      }
                  ) {
                    _id
                    contacts {
                      id
                      order
                      title
                      type
                      value
                    }
                }}"
              }
            `
      })
        .then((resp: any) => {

          if (resp.data.status == 'ok') {
            resolve(resp.data);
          }

        })
        .catch((err: any) => {
          reject(err);
        });
    })
  }

  /**
   * Изменение контакта бейджа (телефон/email/сайт/соц. сеть)
   *
   * @param badgeId, contactId, contacts
   * @return badgeId, contacts
  */
  public static editContact(badgeId: any, contactId: any, contacts: any): Promise<any> {
    return new Promise((resolve, reject) => {
      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
              {
                "query": "mutation {
                  Badge (
                      _id:\\"${badgeId}\\"
                      contacts: {
                        id:\\"${contactId}\\"
                        order: 1
                        title: \\"${ contacts.title }\\"
                        type: \\"${ contacts.type }\\"
                        value: \\"${ contacts.value }\\"
                      }
                  ) {
                    _id
                    contacts {
                      id
                      order
                      title
                      type
                      value
                    }
                }}"
              }
            `
      })
        .then((resp: any) => {

          if (resp.data.status == 'ok') {
            resolve(resp.data);
          }

        })
        .catch((err: any) => {
          reject(err);
        });
    })
  }

    /**
     * Удаление контакта бейджа (телефон/email/сайт/соц. сеть)
     *
     * @param  badgeId, contactId
     * @return badgeId, contacts
    */
  public static deleteContact(badgeId: any, contactId: any): Promise<any> {
  return new Promise((resolve, reject) => {
    Vue.axios({
      url: '/query',
      method: 'POST',
      data: `
            {
              "query": "mutation {
                Badge (
                    _id:\\"${ badgeId }\\"
                    contacts: {
                      remove:\\"${ contactId }\\"
                    }
                ) {
                  _id
                  contacts {
                    id
                    order
                    title
                    type
                    value
                  }
              }}"
            }
          `
    })
      .then((resp: any) => {

        if (resp.data.status == 'ok') {
          resolve(resp.data);
        }

      })
      .catch((err: any) => {
        reject(err);
      });
  })
  }

  /**
   * Добавление контакта бейджа (адрес)
   *
   * @param  badgeId, contacts: { title, type, value }
   * @return badgeId, contacts
  */
  public static addAddress(badgeId: any, contacts: any): Promise<any> {
    return new Promise((resolve, reject) => {
      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
              {
                "query": "mutation {
                  Badge (
                      _id:\\"${badgeId}\\"
                      locations: {
                        address: \\"${ contacts.address }\\"
                        city: \\"${ contacts.city }\\"
                        order: 1
                        _country: \\"${ contacts._country }\\"
                        postcode: \\"${ contacts.postcode }\\"
                        region: \\"${ contacts.region }\\"
                        title: \\"${ contacts.title }\\"
                      }
                  ) {
                    _id
                    locations {
                      address
                      city
                      _country
                      id
                      order
                      postcode
                      region
                      title
                    }
                }}"
              }
            `
      })
        .then((resp: any) => {

          if (resp.data.status == 'ok') {
            resolve(resp.data);
          }

        })
        .catch((err: any) => {
          reject(err);
        });
    })
  }

  /**
   * Изменение контакта бейджа (адрес)
   *
   * @param badgeId, contacts
   * @return badgeId
  */
     public static editAddress(badgeId: any, contacts: any): Promise<any> {
      return new Promise((resolve, reject) => {
        Vue.axios({
          url: '/query',
          method: 'POST',
          data: `
                {
                  "query": "mutation {
                    Badge (
                      _id:\\"${badgeId}\\"
                      locations: {
                        id:\\"${contacts.id}\\"
                        address: \\"${ contacts.address }\\"
                        city: \\"${ contacts.city }\\"
                        order: 1
                        _country: \\"${ contacts._country }\\"
                        postcode: \\"${ contacts.postcode }\\"
                        region: \\"${ contacts.region }\\"
                        title: \\"${ contacts.title }\\"
                      }
                    ) {
                      _id
                      contacts {
                        id
                        order
                        title
                        type
                        value
                      }
                  }}"
                }
              `
        })
          .then((resp: any) => {

            if (resp.data.status == 'ok') {
              resolve(resp.data);
            }

          })
          .catch((err: any) => {
            reject(err);
          });
      })
    }

  /**
   * Удаление адреса
   *
   * @param  badgeId, addressId
   * @return badgeId, location { address }
  */
  public static deleteAddress(badgeId: any, addressId: any): Promise<any> {
    return new Promise((resolve, reject) => {
      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
              {
                "query": "mutation {
                  Badge (
                      _id:\\"${ badgeId }\\"
                      locations: {
                        remove:\\"${ addressId }\\"
                      }
                  ) {
                    _id
                    locations {
                      address
                      city
                      _country
                      id
                      order
                      postcode
                      region
                      title
                    }
                }}"
              }
            `
      })
      .then((resp: any) => {

        if (resp.data.status == 'ok') {
          resolve(resp.data);
        }

      })
      .catch((err: any) => {
        reject(err);
      });
    })
  }


    /**
   * Добавление промо бейджа
   *
   * @param  badgeId, promo: { title, type, value}
   * @return badgeId, promo
  */
  public static addPromo(badgeId: any, promo: any): Promise<any> {
    return new Promise((resolve, reject) => {
      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
              {
                "query": "mutation {
                  Badge (
                      _id:\\"${ badgeId }\\"
                      promo: {
                        order: 1
                        title: \\"${ promo.title }\\"
                        type: \\"${ promo.type }\\"
                        value: \\"${ promo.value }\\"
                      }
                  ) {
                    _id
                    promo {
                      id
                      order
                      title
                      type
                      value
                    }
                }}"
              }
            `
      })
        .then((resp: any) => {

          if (resp.data.status == 'ok') {
            resolve(resp.data);
          }

        })
        .catch((err: any) => {
          reject(err);
        });
    })
  }

  /**
   * Удаление промо бейджа
   *
   * @param  badgeId, promoId
   * @return badgeId, promo
  */
  public static deletePromo(badgeId: any, promoId: any): Promise<any> {
    return new Promise((resolve, reject) => {
      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
              {
                "query": "mutation {
                  Badge (
                      _id:\\"${ badgeId }\\"
                      promo: {
                        remove:\\"${ promoId }\\"
                      }
                  ) {
                    _id
                    promo {
                      id
                      order
                      title
                      type
                      value
                    }
                }}"
              }
            `
      })
        .then((resp: any) => {

          if (resp.data.status == 'ok') {
            resolve(resp.data);
          }

        })
        .catch((err: any) => {
          reject(err);
        });
    })
  }

  /**
   * Получение баджа по ИД
   *
   * @param  badgeId
   * @return Badge
  */
  public static getBadgeById(badgeId : any) {
    return new Promise((resolve, reject) => {
      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
              {
                "query": "query {
                  Badge (
                      _id:\\"${ badgeId }\\"
                  ) {
                    _id
                    about
                    position
                    promo {
                      id
                      order
                      title
                      type
                      value
                    }
                    contacts {
                      id
                      order
                      title
                      type
                      value
                    }
                    locations {
                      _country
                      address
                      city
                      id
                      order
                      postcode
                      region
                      title
                    }
                    name {
                      first
                      gender
                      last
                    }
                }}"
              }
            `
      })
        .then((resp: any) => {
          if (resp.data.status == 'ok') {
            resolve(resp.data);
          }

        })
        .catch((err: any) => {
          reject(err);
        });
    })
  }

}

